import React, { useEffect, useState } from "react";
import {
  Backdrop,
  Button,
  FormFieldSet,
  LogoLoader,
  LoopFieldsSet,
  showToast,
  useFormHandler,
} from "../../../../../components";
import { v4 as uuidv4 } from "uuid";
import { useDispatch, useSelector } from "react-redux";
import {
  addJobStart,
  updateJobDeatilsStart,
} from "../../../../../redux/slices/leads/leadsSlice";
import { useLoginUser } from "../../../../../hooks/useLoginUser";
import { getLocalRestrictionStart } from "../../../../../redux/slices/setting/settingsSlice";

const AddAccount = ({
  onClose,
  defaultWebsite = "",
  defaultJobLocation = "",
  currentCompany,
  selectedProspects = [],
  enableLocationRestrictionCheck = false,
  approvalFlag,
  newJobUiid,
}) => {
  // console.log("defaultWebsite", defaultWebsite);
  // console.log("selectedProspects",selectedProspects)
  const dispatch = useDispatch();
  const restrictions = useSelector(
    (state) => state.settings.generalSettings.raSettings.localRestrictions,
  );
  const loading = useSelector((state) => state?.leads?.loading);
  const { userData: loginUserData } = useLoginUser();
  // const [loading, setLoading] = useState(false);
  const [jobLocationKey, setJobLocationKey] = useState(0);
  const [comments, setComments] = useState("");
  const loginUserUiid = loginUserData?.uiid;
  const initialFormData = {
    website: defaultWebsite,
    jobDescriptionLink: "",
    jobTitle: "",
    city: defaultJobLocation, // prefill job location
    industry: "",
    postersDetails: [
      {
        id: uuidv4(),
        firstName: "",
        lastName: "",
        designation: "",
        email: "",
        // phone: "",
        phone: { code: "", number: "" },
        contactLocation: "",
      },
    ],
  };

  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(initialFormData, {
      // website: { type: "url", required: true },
      jobDescriptionLink: { type: "text", required: true },
      jobTitle: { type: "select", required: true },
      city: { type: "select", required: true },
      // industry: { type: "select", required: true },
      postersDetails: [
        {
          firstName: { type: "text", required: true },
          lastName: { type: "text", required: true },
          designation: { type: "text", required: true },
          email: { type: "email", required: true },
           //phone: { type: "phone", required: true },
          // contactLocation: { type: "select", required: true },
        },
      ],
    });

  console.log("formData", formData);
  useEffect(() => {
    setComments(comments);
  }, [comments]);

  const isStateRestricted = (selectedLocation) => {
    if (!selectedLocation) return false;
    const locationValue = selectedLocation?.value || selectedLocation;
    if (typeof locationValue !== "string") return false;

    let stateName = "";
    if (locationValue.includes("-")) {
      const parts = locationValue.split("-");
      stateName = parts[parts.length - 1].trim();
    } else {
      stateName = locationValue.trim();
    }

    if (!stateName) return false;

    return restrictions.some(
      (r) => r.stateName?.toLowerCase() === stateName.toLowerCase(),
    );
  };

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      website: defaultWebsite || "",
      // city: defaultJobLocation || "",
    }));
  }, [defaultWebsite, defaultJobLocation]);

  useEffect(() => {
    const hasEmptyEmail = formData?.postersDetails?.some(
      (item) => !item?.email || item.email.trim() === "",
    );

    if (hasEmptyEmail && selectedProspects?.length > 0) {
      setFormData({
        ...formData,
        postersDetails: [...selectedProspects],
      });
    }
  }, [selectedProspects]);

  // const parseLocation = (locationString) => {
  //   if (!locationString) return null;
  //   const [cityRaw, stateRaw] = locationString.value
  //     ? locationString.value.split("-")
  //     : locationString.split("-").map((s) => s.trim());
  //   return {
  //     country: "US",
  //     state: stateRaw?.trim() || "",
  //     city: cityRaw?.trim() || "",
  //   };
  // };
  const parseLocation = (location) => {
    if (!location) return null;

    if (typeof location === "object" && location.city && location.state) {
      return {
        country: location.country || "US",
        state: location.state,
        city: location.city,
      };
    }

    if (typeof location === "object" && location.value) {
      if (!location.value.includes("-")) {
        return {
          country: "US",
          state: location.value.trim(),
          city: "",
        };
      }
      const [cityRaw, stateRaw] = location.value
        .split("-")
        .map((s) => s.trim());
      return {
        country: "US",
        state: stateRaw || "",
        city: cityRaw || "",
      };
    }

    if (typeof location === "string") {
      if (!location.value.includes("-")) {
        return {
          country: "US",
          state: location.value.trim(),
          city: "",
        };
      }
      const [cityRaw, stateRaw] = location.split("-").map((s) => s.trim());
      return {
        country: "US",
        state: stateRaw || "",
        city: cityRaw || "",
      };
    }

    return null;
  };

  const addPostersDetails = () => {
    setFormData({
      ...formData,
      postersDetails: [
        ...formData.postersDetails,
        {
          id: uuidv4(),
          firstName: "",
          lastName: "",
          designation: "",
          email: "",
          phone: { code: "", number: "" },
          contactLocation: "",
        },
      ],
    });
  };

  const removePosterDetails = (posterId) => {
    if (formData.postersDetails.length > 1) {
      setFormData({
        ...formData,
        postersDetails: formData.postersDetails.filter(
          (poster) => poster.id !== posterId,
        ),
      });
    }
  };
  const handleSaveEducation = () => {
    try {
      // setLoading(true);
      if (approvalFlag === true) {
        if (currentCompany?.approval?.status === 1) {
          showToast("Company is not approved!.Please contact manager", "error");
          return;
        }
        if (currentCompany?.approval?.status === 3) {
          showToast("Company is rejected!.Please contact manager", "error");
          return;
        }
      }
      const isValid = validateAllFields();
      if (!isValid) return;
      if (formData.postersDetails.length > 5) {
        showToast("You can’t add more than 5 prospects!", "error", 2000);
        return;
      }

      const jobLocation = parseLocation(formData?.city);

      // const jobFields = {
      //   title: formData?.jobTitle?.value ?? formData?.jobTitle,
      //   description: formData?.jobDescriptionLink,
      //   location: jobLocation,
      //   industry: formData?.industry?.value ?? formData.industry,
      //   website: formData?.website,
      // };
      const jobFields = {
        ...(formData?.jobTitle && {
          title: formData.jobTitle.value ?? formData.jobTitle,
        }),
        ...(formData?.jobDescriptionLink && {
          description: formData.jobDescriptionLink,
        }),
        ...(jobLocation && { location: jobLocation }),
        ...(formData?.industry && {
          industry: formData.industry.value ?? formData.industry,
        }),
        ...(formData?.website && { website: formData.website }),
        ...(comments && { comment: comments }),
      };

      // const Prospects = formData.postersDetails.map((poster) => {
      //   return {
      //     firstName: poster.firstName,
      //     lastName: poster.lastName,
      //     designation: poster.designation,
      //     // mobile: poster.phone || { code: "", number: "" },
      //     mobile: {
      //       code: poster.phone?.code || "",
      //       number: Number(poster.phone?.number), // convert to number
      //     },
      //     email: poster.email,
      //     location: parseLocation(poster.contactLocation),
      //   };
      // });

      // const Prospects = formData.postersDetails.map((poster) => {
      //   const { code, number } = parsePhone(poster.phone);
      //   return {
      //     firstName: poster.firstName,
      //     lastName: poster.lastName,
      //     designation: poster.designation,
      //     // mobile: { code, number },
      //     mobile: poster.phone || { code: "", number: "" },
      //     email: poster.email,
      //     location: parseLocation(poster.contactLocation),
      //   };
      // });

      const Prospects = formData.postersDetails.map((poster) => {
        const prospect = {
          ...(poster?.firstName && { firstName: poster.firstName }),
          ...(poster?.lastName && { lastName: poster.lastName }),
          ...(poster?.designation && { designation: poster.designation }),
          // email: poster.email,
          // email: {
          //   email: poster?.email,
          // },
          ...(poster?.email && { email: { email: poster.email } }),
          ...(poster?.contactLocation && {
            location: parseLocation(poster.contactLocation),
          }),
        };

        if (poster.phone?.number) {
          prospect.mobile = {
            code: poster?.phone?.code || "",
            number: Number(poster?.phone?.number),
          };
        }

        return prospect;
      });
      //old one
      // const payload = {
      //   coll: "Job",
      //   postActions: ["AddToProspect"],
      //   payload: {
      //     ...jobFields,
      //     addedBy: loginUserUiid,
      //     companyId: currentCompany?.uiid,
      //     Prospects,
      //   },
      // };

      // dispatch(
      //   addJobStart({
      //     payload,
      //     onSuccess: () => onClose(),
      //   })
      // );

      //new one
      if (newJobUiid) {
        const action = {
          postActions: ["AddToProspect"],
          payload: [{ type: "SET", value: jobFields }],
          additionalPayload: {
            Prospects: Prospects,
            website: formData?.website,
            industry: formData?.industry?.value ?? formData.industry,
            comment: comments,
          },
        };
        dispatch(
          updateJobDeatilsStart({
            uiid: newJobUiid,
            payload: action,
            onSuccess: () => {
              onClose();
            },
          }),
        );
      } else {
        if (!loginUserUiid) throw new Error("User ID is missing");
        const payload = {
          coll: "Job",
          postActions: ["AddToProspect"],
          payload: {
            ...jobFields,
            addedBy: loginUserUiid,
            companyId: currentCompany?.uiid,
            Prospects: Prospects,
          },
        };

        dispatch(
          addJobStart({
            payload,
            onSuccess: () => {
              onClose();
            },
          }),
        );
      }
    } catch (error) {
      console.error("Error in handleSaveEducation:", error);
    } finally {
      // setLoading(false);
    }
  };

  const validateJobOnly = () => {
    const errors = {};

    if (!formData.website) errors.website = "Website is required.";
    if (!formData.jobDescriptionLink)
      errors.jobDescriptionLink = "Job Description is required.";
    if (!formData.jobTitle) errors.jobTitle = "Job Title is required.";
    if (!formData.city) errors.city = "Job Location is required.";
    // if (!formData.industry) errors.industry = "Industry is required.";

    // Only update errors for job fields
    Object.keys(errors).forEach((key) => {
      handleChange(key, formData[key]); // trigger error display in FormFieldSet
    });

    return Object.keys(errors).length === 0;
  };

  const handleSkip = () => {
    // if (!validateJobOnly()) return;
    if (approvalFlag === true) {
      if (currentCompany?.approval?.status === 1) {
        showToast("Company is not approved!.Please contact manager", "error");
        onClose();
        return;
      }
      if (currentCompany?.approval?.status === 3) {
        showToast("Company is rejected!.Please contact manager", "error");
        onClose();
        return;
      }
    }
    const jobLocation = parseLocation(formData?.city);
    const jobFields = {
      ...(formData?.jobTitle && {
        title: formData.jobTitle.value ?? formData.jobTitle,
      }),
      ...(formData?.jobDescriptionLink && {
        description: formData.jobDescriptionLink,
      }),
      ...(jobLocation && { location: jobLocation }),
      ...(formData?.industry && {
        industry: formData.industry.value ?? formData.industry,
      }),
      ...(formData?.website && { website: formData.website }),
      ...(comments && { comment: comments }),
    };
    const Prospects = formData.postersDetails
      .map((poster) => {
        const prospect = {
          ...(poster?.firstName && { firstName: poster.firstName }),
          ...(poster?.lastName && { lastName: poster.lastName }),
          ...(poster?.designation && { designation: poster.designation }),
          // email: poster.email,
          // email: {
          //   email: poster?.email,
          // },
          ...(poster?.email && { email: { email: poster.email } }),
          ...(poster?.contactLocation && {
            location: parseLocation(poster.contactLocation),
          }),
        };

        if (poster.phone?.number) {
          prospect.mobile = {
            code: poster?.phone?.code || "",
            number: Number(poster?.phone?.number),
          };
        }

        return prospect;
      })
      .filter((obj) => Object.keys(obj).length > 0);
    if (newJobUiid) {
      const action = {
        postActions: ["AddToProspect"],
        payload: [{ type: "SET", value: jobFields }],
        additionalPayload: {
          // Prospects: Prospects,
          // ...(Prospects.length > 0 && { Prospects: Prospects }),
          website: formData?.website,
          industry: formData?.industry?.value ?? formData.industry,
        },
      };
      dispatch(
        updateJobDeatilsStart({
          uiid: newJobUiid,
          payload: action,
          onSuccess: () => {
            onClose();
          },
        }),
      );
    } else {
      if (!loginUserUiid) throw new Error("User ID is missing");
      const payload = {
        coll: "Job",
        postActions: ["AddToProspect"],
        payload: {
          ...jobFields,
          addedBy: loginUserUiid,
          companyId: currentCompany?.uiid,
          // Prospects: Prospects,
        },
      };

      dispatch(
        addJobStart({
          payload,
          onSuccess: () => {
            onClose();
          },
        }),
      );
    }
    // old one
    // const payload = {
    //   coll: "Job",
    //   postActions: ["AddToProspect"], // no Prospects
    //   payload: {
    //     title: formData.jobTitle?.value ?? formData.jobTitle,
    //     description: formData.jobDescriptionLink,
    //     location: jobLocation,
    //     industry: formData?.industry?.value ?? formData.industry,
    //     website: formData?.website,
    //     addedBy: loginUserUiid,
    //     companyId: currentCompany?.uiid,
    //   },
    // };

    // dispatch(
    //   addJobStart({
    //     payload,
    //     onSuccess: () => {
    //       onClose();
    //     },
    //   })
    // );
  };

  useEffect(() => {
    if (!restrictions || restrictions.length === 0) {
      const action = {
        coll: "LocationRestriction",
        lim: 100,
        pg: 1,
        ret: "uiid stateName stateCode addedOn",
      };
      dispatch(getLocalRestrictionStart(action));
    }
  }, [restrictions?.length, dispatch]);

  return (
    <div className="w-full min-h-[70vh] flex flex-col justify-between">
      <div className="flex flex-col gap-5">
        <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4">
          <FormFieldSet
            type="text"
            title="Website"
            placeholder="Enter Website"
            value={formData.website}
            onChange={(value) => handleChange("website", value)}
            error={errors.website}
          />
          <FormFieldSet
            type="text"
            title="Job Description"
            placeholder="Enter Description Link"
            value={formData.jobDescriptionLink}
            onChange={(value) => handleChange("jobDescriptionLink", value)}
            error={errors.jobDescriptionLink}
          />
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4">
          <FormFieldSet
            type="atsJobTitle"
            title="Job Title"
            placeholder="Select Job Title"
            value={formData.jobTitle}
            onChange={(value) => handleChange("jobTitle", value)}
            error={errors.jobTitle}
            showButton
            showSearch
          />
          <FormFieldSet
            // type="citiesState"
            key={jobLocationKey}
            type="atscitiesState"
            title="Job Location"
            placeholder="Select Job Location"
            value={formData.city}
            // onChange={(value) => handleChange("city", value)}
            onChange={(value) => {
              if (enableLocationRestrictionCheck && isStateRestricted(value)) {
                showToast(
                  "The selected state has been restricted. Please choose another location.",
                  "error",
                );
                setFormData((prev) => ({ ...prev, city: "" }));
                setJobLocationKey((prev) => prev + 1);
                return;
              }
              handleChange("city", value);
            }}
            showSearch
            parentValue={{ country: "6807640e7ecb9f7d31314b7e" }}
            error={errors.city}
          />
          <FormFieldSet
            type="industry"
            title="Select Industry"
            placeholder="Select Industry"
            options={[]}
            showButton
            showSearch
            value={formData.industry || ""}
            onChange={(value) => handleChange("industry", value)}
            error={errors.industry}
          />
        </div>
        <FormFieldSet
          type="text"
          title="Comments(optional)"
          placeholder="Write your comments here"
          value={comments || ""}
          onChange={(value) => setComments(value)}
        />

        <LoopFieldsSet
          title="Job Posters Details"
          titleConfig={{ tag: "h6" }}
          data={formData.postersDetails}
          onAdd={addPostersDetails}
          onRemove={removePosterDetails}
          gridCols="grid-cols-[repeat(6,1fr)_30px]"
          maxItems={5}
          addButtonTitle="Add More Contacts"
          renderFields={(poster, index) => (
            <>
              <div className="min-w-0 col-span-3 md:col-span-2 xl:col-span-1">
                <FormFieldSet
                  type="text"
                  title="First Name"
                  placeholder="Enter First Name"
                  value={poster.firstName || ""}
                  onChange={(value) =>
                    handleChange(`postersDetails[${index}].firstName`, value)
                  }
                  error={errors.postersDetails?.[index]?.firstName}
                />
              </div>
              <div className="min-w-0 col-span-3 md:col-span-2 xl:col-span-1">
                <FormFieldSet
                  type="text"
                  title="Last Name"
                  placeholder="Enter Last Name"
                  value={poster.lastName || ""}
                  onChange={(value) =>
                    handleChange(`postersDetails[${index}].lastName`, value)
                  }
                  error={errors.postersDetails?.[index]?.lastName}
                />
              </div>
              <div className="min-w-0 col-span-3 md:col-span-2 xl:col-span-1">
                <FormFieldSet
                  type="text"
                  title="Designation"
                  placeholder="Enter Designation"
                  value={poster.designation || ""}
                  onChange={(value) =>
                    handleChange(`postersDetails[${index}].designation`, value)
                  }
                  error={errors.postersDetails?.[index]?.designation}
                />
              </div>
              <div className="min-w-0 col-span-3 md:col-span-2 xl:col-span-1">
                <FormFieldSet
                  type="text"
                  title="Email Id"
                  placeholder="Enter Email Id"
                  value={poster.email || ""}
                  onChange={(value) =>
                    handleChange(`postersDetails[${index}].email`, value)
                  }
                  error={errors.postersDetails?.[index]?.email}
                />
              </div>
              {/* <FormFieldSet
                      type="phoneNew"
                      title="Phone"
                      placeholder="Enter Phone"
                      values={[poster.phone]}
                      onChange={(value) =>
                        handleChange(`postersDetails[${index}].phone`, value[0])
                      }
                      error={errors.postersDetails?.[index]?.phone}
                    /> */}
              <div className="min-w-0 col-span-3 md:col-span-2 xl:col-span-1">
                <FormFieldSet
                  type="phone"
                  title="Phone"
                  placeholder="Enter Mobile Number"
                  value={poster.phone?.number || ""}
                  code={poster.phone?.code || ""}
                  onChange={(fullValue, details) =>
                    handleChange(`postersDetails[${index}].phone`, {
                      code: details.countryCode,
                      number: details.number,
                    })
                  }
                  error={errors.postersDetails?.[index]?.phone}
                />
              </div>
              <div className="min-w-0 col-span-3 md:col-span-2 xl:col-span-1">
                <FormFieldSet
                  type="atscitiesState"
                  title="Contact Location"
                  placeholder="Select Contact Location"
                  value={poster.contactLocation}
                  onChange={(value) =>
                    handleChange(
                      `postersDetails[${index}].contactLocation`,
                      value,
                    )
                  }
                  showSearch
                  parentValue={{ country: "6807640e7ecb9f7d31314b7e" }}
                  error={errors.postersDetails?.[index]?.contactLocation}
                />
              </div>
            </>
          )}
        />
      </div>

      <div className="flex gap-2 justify-end">
        {/* <Button title={"Skip"} variant="outlined" onClick={onClose} /> */}
        <Button
          title={"Skip"}
          variant="outlined"
          onClick={handleSkip}
          disabled={loading}
        />

        <Button
          title={"Save"}
          onClick={handleSaveEducation}
          disabled={loading}
        />
      </div>
      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default AddAccount;
